// extracted by mini-css-extract-plugin
export default {"berandaSection":"style_berandaSection__yZk1I","contentWrapper":"style_contentWrapper__aL1B4","infoSection":"style_infoSection__eryCC","chartSection":"style_chartSection__wAgb-"};